import TextElementView from './text-element-view';

export default class BarcodeElementView extends TextElementView {}
